import { render, staticRenderFns } from "./QueryRecord.vue?vue&type=template&id=115ac4bb&"
import script from "./QueryRecord.vue?vue&type=script&lang=js&"
export * from "./QueryRecord.vue?vue&type=script&lang=js&"
import style0 from "./QueryRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports